export default () => {
  const halfBgContents = document.querySelectorAll('.js-halfBgContent');

  if(halfBgContents) {
    halfBgContents.forEach(halfBgContent => {
      const column = halfBgContent.querySelector('.wp-block-column');
      const columnHeight = column.offsetHeight; 
    column.style.marginTop = `-${columnHeight / 2}px`;
    });
  }

}
